// extracted by mini-css-extract-plugin
module.exports = {"columns":"columns__1mpZ2","formInput":"formInput__2c4qJ","preview":"preview__2MC81"};